import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { masterOutletDistConfig } from "@/lib/datasetRegistry"

// Thin config module — the whole page is the parameterized <DatasetUploadsPage>
// driven by `masterOutletDistConfig` (app/frontend/lib/datasetRegistry.ts). Controller
// renders this via inertia page name "admin/master_outlet_dist/Uploads".
export default function AdminMasterOutletDistUploads(props: Omit<DatasetUploadsPageProps, "config">) {
  return <DatasetUploadsPage config={masterOutletDistConfig} {...props} />
}
